import React from 'react';

const ErrorMessage = () => {
    return (
        <div className='flex justify-center pt-10'>
            <img className='w-2/4' src="img-404.jpg" alt="ErrorMessage" />
        </div>
    );
};

export default ErrorMessage;